import React, {useEffect, useRef, useState} from "react";
import './updatingDirectories.scss';
import {HCheckbox} from "../../validation/HForm";
import {IndexModal} from "./IndexModal/IndexModal";
import {useDispatch, useSelector} from "react-redux";
import {
    changeDirectoriesChackBox,
    directories, errorMessages, loaderDirectories, openAlertSuccess,
    openModal, setIssuingAuthorityDirectory, setSoatoDirectory,
    setTerroristDirectory,
} from "../../redux/actions/directories";
import JSZip from "jszip";
import {Message} from "../utilites";
import DeleteIcon from '../../assets/icons/trash.svg';
import BasicAlert from "../utilites/Alert/Alert";

export const UpdatingDirectories = () => {
    const {
        terroristIndex,
        soatoIndex,
        issuingAuthority,
        isModal,
        errorMessage,
        terroristCheckbox,
        soatoCheckbox,
        issuingAuthorityCheckbox,
        terroristDirectory,
        soatoDirectory,
        issuingAuthorityDirectory,
        isAlert
    } = useSelector(({directories}) => directories)
    const [disabledIndex, setDisabledIndex] = useState(true)
    const dispatch = useDispatch()
    const refTerrorist = useRef()
    const refSoato = useRef()
    const refIssuingAuthority = useRef()
    const allowedFileZip = ['application/json'];
    const allowedFileTypeTerroristZip = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];

    useEffect(() => {
        if (soatoCheckbox
            || terroristCheckbox
            || issuingAuthorityCheckbox
            || terroristDirectory
            || soatoDirectory
            || issuingAuthorityDirectory) {
            setDisabledIndex(false)
        } else {
            setDisabledIndex(true)
        }
    }, [
        terroristCheckbox,
        soatoCheckbox,
        issuingAuthorityCheckbox,
        terroristDirectory,
        issuingAuthorityDirectory,
        soatoDirectory
    ])

    const zipFile = (file) => {
        if (!file) {
            return
        }
        const zip = new JSZip()
        zip.file(file.name, file)

        return zip.generateAsync({type: 'blob', compression: 'DEFLATE'})
    }

    const openModalIndex = () => {
        dispatch(openModal({isOpen: true}))
    }

    const closeModalIndex = () => {
        dispatch(openModal({isOpen: false}))
    }

    const onCloseAlert = () => {
        dispatch(openAlertSuccess())
    }

    const submitDirectories = async () => {
        dispatch(loaderDirectories(true))

        const terrorist = await zipFile(terroristDirectory)
        const soato = await zipFile(soatoDirectory)
        const issuingAuthority = await zipFile(issuingAuthorityDirectory)

        dispatch(directories({
            terrorist,
            issuingAuthority,
            soato,
            terroristCheckbox,
            soatoCheckbox,
            issuingAuthorityCheckbox
        }))

        refTerrorist.current.value = ''
        refSoato.current.value = ''
        refIssuingAuthority.current.value = ''
    }

    const handleClear = (value) => {
        if (value === 'terroristDirectory') {
            refTerrorist.current.value = ''
            dispatch(setTerroristDirectory(null))
        }
        if (value === 'soatoDirectory') {
            refSoato.current.value = ''
            dispatch(setSoatoDirectory(null))
        }
        if (value === 'issuingAuthority') {
            refIssuingAuthority.current.value = ''
            dispatch(setIssuingAuthorityDirectory(null))
        }
    };

    const handleCheckboxChange = (event) => {
        dispatch(changeDirectoriesChackBox(event.target.name));
    }

    const onChangeFileTerroristZip = (event) => {
        const file = event.target.files[0];
        if (file && allowedFileTypeTerroristZip.includes(file.type)) {
            dispatch(setTerroristDirectory(file))
        } else {
            dispatch(errorMessages('Файл должен быть расширения .XLSX'))
        }
        refTerrorist.current.value = ''
    }

    const onChangeFileSoatoZip = (event) => {
        const file = event.target.files[0];
        if (file && allowedFileZip.includes(file.type)) {
            dispatch(setSoatoDirectory(event.target.files[0]))
        } else {
            dispatch(errorMessages('Файл должен быть расширения .json'))
        }
        refSoato.current.value = '';
    }

    const onChangeFileIssuingAuthorityZip = (event) => {
        const file = event.target.files[0];
        if (file && allowedFileZip.includes(file.type)) {
            dispatch(setIssuingAuthorityDirectory(event.target.files[0]))
        } else {
            dispatch(errorMessages('Файл должен быть расширения .json'))
        }
        refIssuingAuthority.current.value = ''
    }

    return (
        <div className="content-inner-data-container">
            {errorMessage && <Message type="error" text={errorMessage}/>}
            <table className="updatingDirectories-container">
                <tbody>
                <tr>
                    <td>
                        <label className={terroristCheckbox ? "updatingDirectories-index-disabledButton" : "button loadButton"}
                               htmlFor="terroristDirectory">
                            Загрузить справочник террористов
                        </label>
                        <input className="updatingDirectories-input"
                               type="file"
                               id="terroristDirectory"
                               name="terroristDirectory"
                               accept=".XLSX"
                               onChange={(e) => onChangeFileTerroristZip(e)}
                               ref={refTerrorist}
                               disabled={terroristCheckbox}
                        />
                    </td>
                    <td>
                        <label className={soatoCheckbox ? "updatingDirectories-index-disabledButton" : "button loadButton"}
                               htmlFor="soatoDirectory">
                            Загрузить справочник СОАТО
                        </label>
                        <input className="updatingDirectories-input"
                               type="file"
                               id="soatoDirectory"
                               name="soatoDirectory"
                               accept=".json"
                               onChange={(e) => onChangeFileSoatoZip(e)}
                               ref={refSoato}
                               disabled={soatoCheckbox}
                        />
                    </td>
                    <td>
                        <label className={issuingAuthorityCheckbox ? "updatingDirectories-index-disabledButton" : "button loadButton"}
                               htmlFor="issuingAuthority">
                            Загрузить справочник "Органов выдавших документ"
                        </label>
                        <input className={"updatingDirectories-input"}
                               type="file"
                               name="issuingAuthority"
                               id="issuingAuthority"
                               accept=".json"
                               onChange={(e) => onChangeFileIssuingAuthorityZip(e)}
                               ref={refIssuingAuthority}
                               disabled={issuingAuthorityCheckbox}
                        />
                    </td>
                    <td>
                        <button disabled={disabledIndex} onClick={openModalIndex}
                                className={disabledIndex ? "updatingDirectories-index-disabledButton" : "updatingDirectories-index-button"}>
                            <span>Проиндексировать</span>
                        </button>
                    </td>
                </tr>
                <tr>
                    <td className="updatingDirectories-item">
                        {terroristDirectory && <div className="updatingDirectories-file">
                            <span>{terroristDirectory.name}</span>
                            <DeleteIcon className="updatingDirectories-file-deleteIcon"
                                        onClick={() => handleClear('terroristDirectory')}/>
                        </div>}
                    </td>
                    <td className="updatingDirectories-item">
                        {soatoDirectory && <div className="updatingDirectories-file">
                            <span>{soatoDirectory.name}</span>
                            <DeleteIcon onClick={() => handleClear('soatoDirectory')}
                                        className="updatingDirectories-file-deleteIcon"
                            />
                        </div>}
                    </td>
                    <td className="updatingDirectories-item">
                        {issuingAuthorityDirectory && <div className="updatingDirectories-file">
                            <span>{issuingAuthorityDirectory.name}</span>
                            <DeleteIcon onClick={() => handleClear("issuingAuthority")}
                                        className="updatingDirectories-file-deleteIcon"
                            />
                        </div>}
                    </td>
                </tr>
                <tr>
                    <td className="updatingDirectories-item">
                        {terroristIndex && <span>Проиндексированных справочников: {terroristIndex}</span>}
                        {terroristIndex && terroristIndex !== 0 ? (
                          <span>Проиндексированных справочников: {terroristIndex}</span>
                        ) : terroristIndex === 0 ? (
                          <span>Проиндексированных справочников: 0</span>
                        ) : null}
                    </td>
                    <td className="updatingDirectories-item">
                        {soatoIndex && soatoIndex !== 0 ? (
                          <span>Проиндексированных справочников: {soatoIndex}</span>
                        ) : soatoIndex === 0 ? (
                          <span>Проиндексированных справочников: 0</span>
                        ) : null}
                    </td>
                    <td className="updatingDirectories-item">
                        {issuingAuthority && issuingAuthority !== 0 ? (
                          <span>Проиндексированных справочников: {issuingAuthority}</span>
                        ) : issuingAuthority === 0 ? (
                          <span>Проиндексированных справочников: 0</span>
                        ) : null}
                    </td>
                </tr>
                <tr>
                    <td className="updatingDirectories-item updatingDirectories-terrorist">
                        <HCheckbox
                            label='Возврат к базовому справочнику террористов'
                            name="terroristCheckbox"
                            checked={terroristCheckbox}
                            disabled={terroristDirectory}
                            onChange={handleCheckboxChange}
                        />
                    </td>
                    <td className="updatingDirectories-item updatingDirectories-soato">
                        <HCheckbox
                            label="Возврат к базовому справочнику СОАТО"
                            name="soatoCheckbox"
                            checked={soatoCheckbox}
                            disabled={soatoDirectory}
                            onChange={handleCheckboxChange}
                        />
                    </td>
                    <td className="updatingDirectories-item updatingDirectories-issuingAuthorities">
                        <HCheckbox
                            label='Возврат к базовому справочнику "Органов выдавших документ"'
                            name="issuingAuthorityCheckbox"
                            checked={issuingAuthorityCheckbox}
                            disabled={issuingAuthorityDirectory}
                            onChange={handleCheckboxChange}
                        />
                    </td>
                </tr>
                </tbody>
            </table>
            <IndexModal isOpen={isModal}
                        stateModalHandler={closeModalIndex}
                        submitDirectories={submitDirectories}
            />
            <BasicAlert onClose={onCloseAlert}
                        message="Действие выполнено успешно"
                        isOpen={isAlert}
            />
        </div>
    )
}
